import CurrencyFormat from "utils/currencyFormat";
import * as actions from "./actionTypes";
import errorReducer from "utils/errorReducer";
import { decryptPayload } from "utils/encrypt_decrypt";

const initialState = {
	goalsSavingsLoading: false,
	goalsSavingsData: [],
	goalSavingsCSV: [],

	flexSavingsLoading: false,
	flexSavingsData: [],

	savingsDetailsLoading: false,
	savingsDetailsData: null,
	selectedSavingsItem: null,
	savingsMetricsLoading: false,
	savingsMetricsData: null,

	savingsTrxLoading: false,
	savingsTrxData: null,

	downloadGoalSavingsLoading: false,
	downloadGoalSavingsData: null,
	
	pauseGoalSavingsLoading: false,
	cancelGoalSavingsLoading: false,
};

export default function reducer(state = initialState, action) {
	switch (action.type) {

		case actions.DOWNLOAD_GOALS_SAVINGS_START:
			state = {
				...state,
				downloadGoalSavingsLoading: true,
				downloadGoalSavingsData: null,
			};
			return state;

		case actions.DOWNLOAD_GOALS_SAVINGS_DONE:
			state = {
				...state,
				downloadGoalSavingsLoading: false,
				downloadGoalSavingsData: action.payload,
			};
			return state;

		case actions.DOWNLOAD_GOALS_SAVINGS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				downloadGoalSavingsLoading: false,
				downloadGoalSavingsData: null,
			};
			return state;

		case actions.GET_SAVINGS_TRX_START:
			state = {
				...state,
				savingsTrxLoading: true,
			};
			return state;

		case actions.GET_SAVINGS_TRX_DONE:
			const decryptedSavingsDetailsTransactions = decryptPayload(action.payload);
			state = {
				...state,
				savingsTrxLoading: false,
				savingsTrxData: decryptedSavingsDetailsTransactions?.data,
			};
			return state;

		case actions.GET_SAVINGS_TRX_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				savingsTrxLoading: false,
				savingsTrxData: null,
			};
			return state;


		case actions.GET_SAVINGS_DETAILS_START:
			state = {
				...state,
				savingsDetailsLoading: true,
			};
			return state;

		case actions.GET_SAVINGS_DETAILS_DONE:
			const decryptedSavingsDetailsData = decryptPayload(action.payload);
			state = {
				...state,
				savingsDetailsLoading: false,
				savingsDetailsData: decryptedSavingsDetailsData?.data,
			};
			return state;

		case actions.GET_SAVINGS_DETAILS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				savingsDetailsLoading: false,
				savingsDetailsData: null,
			};
			return state;

		case actions.SELECT_SAVINGS_ITEM:
			state = {
				...state,
				selectedSavingsItem: action.payload,
			};
			return state;

		case actions.GET_ALL_GOALS_SAVINGS_START:
			state = {
				...state,
				goalsSavingsLoading: true,
				goalsSavingsData: [],
				goalSavingsCSV: [],
			};
			return state;

		case actions.GET_ALL_GOALS_SAVINGS_DONE:
			const decryptedData = decryptPayload(action.payload);
			const formattedData = decryptedData?.data?.data?.map(item => {
				const dailyDepositInNaira = CurrencyFormat(item?.amount / 100)
				const targetAmountInNaira = CurrencyFormat(item?.target / 100)
				return {
					...item,
					dailyDepositInNaira,
					targetAmountInNaira
				}
			})
			state = {
				...state,
				goalsSavingsLoading: false,
				goalsSavingsData: decryptedData?.data,
				goalSavingsCSV: formattedData
			};
			return state;

		case actions.GET_ALL_GOALS_SAVINGS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				goalsSavingsLoading: false,
				goalsSavingsData: [],
				goalSavingsCSV: []
			};
			return state;

		case actions.GET_SAVINGS_METRICS_START:
			state = {
				...state,
				savingsMetricsLoading: true,
				savingsMetricsData: null
			};
			return state;

		case actions.GET_SAVINGS_METRICS_DONE:
			const decryptedSavingsMetrics = decryptPayload(action.payload);
			state = {
				...state,
				savingsMetricsLoading: false,
				savingsMetricsData: decryptedSavingsMetrics?.data || {}
			};
			return state;

		case actions.GET_SAVINGS_METRICS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				savingsMetricsLoading: false,
				savingsMetricsData: null
			};
			return state;

		case actions.PAUSE_GOALS_SAVINGS_START:
			state = {
				...state,
				pauseGoalSavingsLoading: true,
			};
			return state;

		case actions.PAUSE_GOALS_SAVINGS_DONE:
			state = {
				...state,
				pauseGoalSavingsLoading: false,
			};
			return state;

		case actions.PAUSE_GOALS_SAVINGS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				pauseGoalSavingsLoading: false,
			};
			return state;

		case actions.CANCEL_GOALS_SAVINGS_START:
			state = {
				...state,
				cancelGoalSavingsLoading: true,
			};
			return state;

		case actions.CANCEL_GOALS_SAVINGS_DONE:
			state = {
				...state,
				cancelGoalSavingsLoading: false,
			};
			return state;

		case actions.CANCEL_GOALS_SAVINGS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				cancelGoalSavingsLoading: false,
			};
			return state;

		case actions.GET_ALL_FLEX_SAVINGS_START:
			state = {
				...state,
				flexSavingsLoading: true,
				flexSavingsData: [],
			};
			return state;

		case actions.GET_ALL_FLEX_SAVINGS_DONE:
			const decryptedFlexSavingsData = decryptPayload(action.payload);
			state = {
				...state,
				flexSavingsLoading: false,
				flexSavingsData: decryptedFlexSavingsData?.data,
			};
			return state;

		case actions.GET_ALL_FLEX_SAVINGS_FAILED:
			errorReducer(action.payload);
			state = {
				...state,
				flexSavingsLoading: false,
				flexSavingsData: [],
			};
			return state;

		default:
			return state;
	}
}
